/* WIP Lior notes v22 — Flashy hide + social/accordion on mobile only; clear on desktop/resize */
(function () {
  var SELECTOR =
    'footer .mobile-only.mobile-footer, footer .group-block.mobile-only.mobile-footer, footer accordion-custom.mobile-only, footer accordion-custom.mobile-only.menu, footer .mobile-only.menu.menu--accordion, footer .mobile-only.mobile-footer .social-icons__wrapper, footer .mobile-footer .social-icons__wrapper';

  function isMobile() {
    return window.matchMedia && window.matchMedia('(max-width: 767px)').matches;
  }

  function hideFlashy() {
    return; /* disabled: allow Flashy popups and forms in footer */
    document.querySelectorAll('footer flashy-popup').forEach(function (el) {
      el.style.setProperty('display', 'none', 'important');
      el.setAttribute('hidden', '');
      try { el.remove(); } catch (e) {}
    });
  }

  function clearInline(el) {
    ['display', 'visibility', 'opacity', 'height', 'max-height', 'overflow', 'width', 'max-width'].forEach(function (prop) {
      el.style.removeProperty(prop);
    });
    el.removeAttribute('hidden');
  }

  function showSocialAccordionMobile() {
    document.querySelectorAll(SELECTOR).forEach(function (el) {
      if (el.matches('.social-icons__wrapper')) {
        el.style.setProperty('display', 'flex', 'important');
      } else {
        el.style.setProperty('display', 'block', 'important');
      }
      el.style.setProperty('visibility', 'visible', 'important');
      el.style.setProperty('opacity', '1', 'important');
      el.style.setProperty('height', 'auto', 'important');
      el.style.setProperty('max-height', 'none', 'important');
      el.style.setProperty('overflow', 'visible', 'important');
      el.style.setProperty('width', '100%', 'important');
      el.style.setProperty('max-width', '100%', 'important');
      el.removeAttribute('hidden');
    });
  }

  function run() {
    hideFlashy();
    if (isMobile()) {
      showSocialAccordionMobile();
    } else {
      document.querySelectorAll(SELECTOR).forEach(clearInline);
    }
  }

  run();
  document.addEventListener('DOMContentLoaded', run);
  window.addEventListener('load', run);
  window.addEventListener('resize', function () {
    window.clearTimeout(run._t);
    run._t = window.setTimeout(run, 150);
  });
  var n = 0;
  var t = setInterval(function () {
    run();
    if (++n >= 25) clearInterval(t);
  }, 400);
})();

(function(){var sx=0,sy=0,lt=0;function target(){var i,l=document.querySelectorAll('footer flashy-popup');for(i=0;i<l.length;i++){if(l[i].offsetHeight>50)return l[i]}l=document.querySelectorAll('footer [data-inject-flashy-popup]');for(i=0;i<l.length;i++){if(l[i].offsetParent!==null&&l[i].parentElement.offsetHeight>50)return l[i].parentElement}return document.querySelector('footer')}function run(){var t=target();if(!t)return;var h=t.offsetHeight||0;var y=t.getBoundingClientRect().top+window.pageYOffset-Math.max(0,(window.innerHeight-h)/2);window.scrollTo({top:y,behavior:'smooth'})}function go(e){var a=e.target&&e.target.closest&&e.target.closest('a[href*=bottom-footer]');if(!a||!/מועדון/.test(a.textContent))return;if(!target())return;e.preventDefault();var now=Date.now();if(now-lt<600)return;lt=now;run();setTimeout(run,1000);setTimeout(run,2200)}document.addEventListener('click',go,true);document.addEventListener('touchstart',function(e){var t=e.touches[0];sx=t.clientX;sy=t.clientY},{capture:true,passive:true});document.addEventListener('touchend',function(e){var t=e.changedTouches[0];if(Math.abs(t.clientX-sx)<10&&Math.abs(t.clientY-sy)<10)go(e)},true)})();